import { ALPHANUMERIC_CHAR_TYPES } from "@/utils/checkCharTypeValidator";
import { validator } from "@/utils/validator";

export const masterDataMainIndustrySchema = validator.object().shape({
  mainIndustry: validator.string().emptyToNull().label("主たる業種").required(),
  gzMainIndustryRenewVisaCsvCode: validator
    .string()
    .emptyToNull()
    .autoTransformToHalfWidth()
    .isValidCheckCharType(ALPHANUMERIC_CHAR_TYPES)
    .length(3)
    .label("期間更新CSVのコード（列GZ）")
    .required(),
});
